import script from "./PaperFileDrop.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperFileDrop.vue?vue&type=script&setup=true&lang=js"

import "./PaperFileDrop.vue?vue&type=style&index=0&id=724ac5b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724ac5b6"]])

export default __exports__